import React, { PropsWithChildren } from 'react';

import { css, cx } from '@emotion/css';
import MuiCardContent from '@mui/material/CardContent';

import { useStyles } from '@/hooks/useStyles.ts';
import { HandledErrorPage } from '@/pages/HandledErrorPage.tsx';
import { QueryAwait } from '@/queries/QueryAwait.tsx';
import { Theme } from '@/theme/CreateTheme.ts';
import { CenteredLoader } from '@/uiKit/atoms/pending/CenteredLoader.tsx';
import { AtomProps } from '@/uiKit/atoms/utils/AtomTypes.ts';

export type BaseCardContentProps = PropsWithChildren<{}>;

export type CardContentProps = AtomProps<BaseCardContentProps>;

export const CardContent: React.FC<CardContentProps> = ({
  children,
  className,
}) => {
  const styles = useStyles(makeStyles);

  return (
    <MuiCardContent className={cx(styles.root, 'scrollbar', className)}>
      <QueryAwait
        errorFallback={HandledErrorPage}
        pendingFallback={CenteredLoader}
      >
        {children}
      </QueryAwait>
    </MuiCardContent>
  );
};

const makeStyles = (theme: Theme) => ({
  root: css({
    flex: '1 1',
    overflow: 'auto',
    padding: theme.spacing(10, 32),
  }),
});
